import { detach, updateCSSText } from '@syncfusion/ej2-base';
import { events } from '../../common/constant';
export class FloatingIconRenderer {
    /**
     * Creates a new FloatingIconManager instance
     *
     * @param {BlockEditor} editor The parent BlockEditor instance
     */
    constructor(editor) {
        this.editor = editor;
        this.addEventListeners();
    }
    addEventListeners() {
        this.editor.on(events.destroy, this.destroy, this);
    }
    removeEventListeners() {
        this.editor.off(events.destroy, this.destroy);
    }
    /**
     * Creates the floating icons for the editor
     *
     * @returns {void}
     * @hidden
     */
    createFloatingIcons() {
        this.floatingIconContainer = this.editor.createElement('div', { className: 'e-floating-icons', id: `${this.editor.element.id}_floatingicons` });
        const addIcon = this.editor.createElement('span', { className: 'e-floating-icon e-icons e-block-add-icon' });
        const dragIcon = this.editor.createElement('span', { className: 'e-floating-icon e-icons e-block-drag-icon', attrs: { draggable: 'true' } });
        this.floatingIconContainer.appendChild(addIcon);
        this.floatingIconContainer.appendChild(dragIcon);
        const cssText = 'position: absolute; display: none; pointer-events: none;';
        updateCSSText(this.floatingIconContainer, cssText);
        this.editor.element.appendChild(this.floatingIconContainer);
        this.renderFloatingIconTooltips();
        this.editor.blockManager.observer.notify('floatingIconsCreated');
    }
    renderFloatingIconTooltips() {
        this.addIconTooltip = this.editor.tooltipRenderer.renderTooltip({
            element: this.floatingIconContainer,
            target: '.e-block-add-icon',
            position: 'TopCenter',
            showTipPointer: true,
            windowCollision: true,
            cssClass: 'e-be-floating-icon-tooltip',
            content: this.getTooltipContent('add')
        });
        this.dragIconTooltip = this.editor.tooltipRenderer.renderTooltip({
            element: this.floatingIconContainer,
            target: '.e-block-drag-icon',
            position: 'TopCenter',
            showTipPointer: true,
            windowCollision: true,
            cssClass: 'e-be-floating-icon-tooltip',
            content: this.getTooltipContent('drag')
        });
    }
    getTooltipContent(iconType) {
        if (iconType === 'add') {
            const spenEle = document.createElement('span');
            spenEle.textContent = this.editor.l10n.getConstant('addIconTooltip');
            return spenEle;
        }
        const container = document.createElement('div');
        container.innerHTML = `
            <span>${this.editor.l10n.getConstant('dragIconTooltipActionMenu')}</span><br>
            <span>${this.editor.l10n.getConstant('dragIconTooltip')}</span>
        `;
        return container;
    }
    /**
     * Updates the tooltip content for the floating icons.
     *
     * @returns {void}
     * @hidden
     */
    updateFloatingIconTooltipContent() {
        this.addIconTooltip.content = this.getTooltipContent('add');
        this.addIconTooltip.dataBind();
        this.dragIconTooltip.content = this.getTooltipContent('drag');
        this.dragIconTooltip.dataBind();
    }
    destroy() {
        this.removeEventListeners();
        this.editor.tooltipRenderer.destroyTooltip(this.addIconTooltip);
        this.addIconTooltip = null;
        this.editor.tooltipRenderer.destroyTooltip(this.dragIconTooltip);
        this.dragIconTooltip = null;
        detach(this.floatingIconContainer);
        this.floatingIconContainer = null;
    }
}
